import { container } from "tsyringe";
import moment from 'moment';
import 'moment/locale/es';
import { isTestMarketCountry } from "../../../utils/testMarket";
const SubmitSearch = ({ selectedPickupLocation, selectedReturnLocation, startDate, endDate, startTime, endTime, checked, formData, currentDate }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const getDaysDifference = container.resolve("iUseCaseGetDaysDifferences");
    sessionStorage.setItem("startDate", startDate[0]);
    sessionStorage.setItem("startDate_", moment(startDate[1]).format('YYYY-MM-DD'));
    sessionStorage.setItem("endDate", endDate[0]);
    sessionStorage.setItem("endDate_", moment(endDate[1]).format('YYYY-MM-DD'));
    const sanitize = (v) => (v === "undefined" || v === "null" ? "" : v);
    const pickupLocationName = sanitize(((_a = selectedPickupLocation === null || selectedPickupLocation === void 0 ? void 0 : selectedPickupLocation[0]) !== null && _a !== void 0 ? _a : "").toString());
    const pickupLocationCode = sanitize(((_b = selectedPickupLocation === null || selectedPickupLocation === void 0 ? void 0 : selectedPickupLocation[1]) !== null && _b !== void 0 ? _b : "").toString());
    const pickupLocationTypeCode = sanitize(((_c = selectedPickupLocation === null || selectedPickupLocation === void 0 ? void 0 : selectedPickupLocation[2]) !== null && _c !== void 0 ? _c : "").toString());
    const returnLocationName = checked == true
        ? sanitize(((_d = selectedReturnLocation === null || selectedReturnLocation === void 0 ? void 0 : selectedReturnLocation[0]) !== null && _d !== void 0 ? _d : "").toString())
        : pickupLocationName;
    const returnLocationCode = checked == true
        ? sanitize(((_e = selectedReturnLocation === null || selectedReturnLocation === void 0 ? void 0 : selectedReturnLocation[1]) !== null && _e !== void 0 ? _e : "").toString())
        : pickupLocationCode;
    const returnLocationTypeCode = checked == true
        ? sanitize(((_f = selectedReturnLocation === null || selectedReturnLocation === void 0 ? void 0 : selectedReturnLocation[2]) !== null && _f !== void 0 ? _f : "").toString())
        : pickupLocationTypeCode;
    sessionStorage.setItem("pickupLocation", pickupLocationName);
    sessionStorage.setItem("pickupLocationCode", pickupLocationCode);
    sessionStorage.setItem("pickupLocationTypeCode", pickupLocationTypeCode);
    sessionStorage.setItem("returnLocation", returnLocationName);
    sessionStorage.setItem("returnLocationCode", returnLocationCode);
    sessionStorage.setItem("returnLocationTypeCode", returnLocationTypeCode);
    sessionStorage.setItem("pickupTime", startTime[0]);
    sessionStorage.setItem("returnTime", endTime[0]);
    sessionStorage.setItem("pickupTime_", startTime[1]);
    sessionStorage.setItem("returnTime_", endTime[1]);
    sessionStorage.setItem("offerId", "");
    //if the url contains /collections set the storage item "searchId" to ""
    if (window.location.href.includes("/collections")) {
        sessionStorage.setItem("searchId", "");
    }
    const urlParams = new URLSearchParams(window.location.search);
    const formattedStartDate = "" + moment(startDate[1]).format('YYYY-MM-DD');
    const formattedEndDate = "" + moment(endDate[1]).format('YYYY-MM-DD');
    getDaysDifference.handle(formattedStartDate, formattedEndDate).then((days) => {
        if (days === 0) {
            formData.totalDays = 1;
        }
        else {
            formData.totalDays = days;
        }
    });
    const pathname = window.location.pathname;
    const normalizedCountry = (sessionStorage.getItem("country") || "").toString().trim().toUpperCase();
    const isTestMarket = isTestMarketCountry(normalizedCountry || "US");
    const pathSegment = ((_g = pathname.split("/")[1]) === null || _g === void 0 ? void 0 : _g.toLowerCase()) || "";
    const sessionLocale = (sessionStorage.getItem("locale") || "").toLowerCase();
    const localeMappings = {
        "es-es": "/es-es",
        "es-eu": "/es-es",
        "en-gb": "/en-gb",
        "en-uk": "/en-gb",
    };
    const lockedLocales = new Set(["es-es", "en-gb"]);
    const getBaseLocale = (rawLocale) => rawLocale.slice(0, 2);
    const normalizeLocale = (rawLocale) => rawLocale.replace(/_/g, "-");
    const resolveLocale = () => {
        const candidateRaw = pathSegment && !["collections", "pages"].includes(pathSegment) ? pathSegment : sessionLocale;
        const candidate = normalizeLocale(candidateRaw);
        if (candidate === "en")
            return "";
        if (lockedLocales.has(candidate))
            return `/${candidate}`;
        const mappedLocale = localeMappings[candidate];
        if (mappedLocale)
            return mappedLocale;
        const baseLocale = getBaseLocale(candidate);
        if (baseLocale && baseLocale !== "en")
            return `/${baseLocale}`;
        return "";
    };
    let locale = resolveLocale();
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    const port = window.location.port;
    const url = `${protocol}//${hostname}${port != "" ? ":" + port : ""}`;
    //if the app param and the currency params are in the url the currency is set to value of the currency param
    let currency = "USD";
    if (window.location.href.includes("app") && window.location.href.includes("currency=")) {
        currency = urlParams.get("currency") || "USD";
        if (urlParams.get("currency") == "USD") {
            currency = "USD";
        }
    }
    else {
        currency = sessionStorage.getItem("currency") || "USD";
    }
    //if local contains "/collections" delete it from it}
    if (locale.includes("/collections")) {
        locale = locale.replace("/collections", "");
    }
    const collectionsPath = `${locale}/collections/all`.replace(/\/{2,}/g, "/");
    let hrefUrl = "";
    //if the url contains a param called oldcar set it in a variable to oldcar with and & so we can add it to the end of the redirect url if not set it to empty string
    const oldcar = urlParams.get("oldcar") || "";
    const oldcarParam = oldcar != "" ? "&oldcar=" + oldcar : "";
    const normalizeSessionParam = (value) => {
        if (value == null)
            return "";
        const trimmed = value.trim();
        if (trimmed === "" || trimmed.toLowerCase() === "undefined" || trimmed.toLowerCase() === "null") {
            return "";
        }
        return trimmed;
    };
    const getSessionParam = (key) => normalizeSessionParam(sessionStorage.getItem(key));
    const pickCountry = sessionStorage.getItem("pickCountry");
    const dropCountry = sessionStorage.getItem("dropCountry");
    let pickPlaceId = sessionStorage.getItem("pickPlaceId");
    let pickDataSource = sessionStorage.getItem("pickDataSource");
    let dropPlaceId = sessionStorage.getItem("dropPlaceId");
    let dropDataSource = sessionStorage.getItem("dropDataSource");
    if (isTestMarket) {
        const shouldMirrorDrop = !checked ||
            (selectedReturnLocation === null || selectedReturnLocation === void 0 ? void 0 : selectedReturnLocation[1]) === "" ||
            (selectedReturnLocation === null || selectedReturnLocation === void 0 ? void 0 : selectedReturnLocation[1]) == null;
        if (shouldMirrorDrop) {
            if (!dropPlaceId)
                dropPlaceId = pickPlaceId;
            if (!dropDataSource)
                dropDataSource = pickDataSource;
            if (dropPlaceId)
                sessionStorage.setItem("dropPlaceId", dropPlaceId);
            if (dropDataSource)
                sessionStorage.setItem("dropDataSource", dropDataSource);
        }
    }
    if (selectedReturnLocation[1] == "") {
        hrefUrl = `${collectionsPath}?&pickuplocation=` + selectedPickupLocation[1] + "&returnlocation=" + selectedPickupLocation[1] + "&pickUpDate=" + formattedStartDate.replace(/\//g, '-') + "&returnDate=" + formattedEndDate.replace(/\//g, '-') + "&pickUpTime=" + startTime[1] + "&returnTime=" + endTime[1] + "&totalDays=" + formData.totalDays + "&pickupLocName=" + encodeURIComponent(selectedPickupLocation[0]) + "&returnLocName=" + encodeURIComponent(selectedPickupLocation[0]) + "&dloc=" + selectedReturnLocation[1] + "&ploc=1" + "&pickupLocationTypeCode=" + selectedPickupLocation[2] + "&returnLocationTypeCode=" + selectedPickupLocation[2] + "&currency=" + currency + "&pickCountry=" + pickCountry + "&dropCountry=" + dropCountry + oldcarParam;
    }
    else {
        hrefUrl = `${collectionsPath}?&pickuplocation=` + selectedPickupLocation[1] + "&returnlocation=" + selectedReturnLocation[1] + "&pickUpDate=" + formattedStartDate.replace(/\//g, '-') + "&returnDate=" + formattedEndDate.replace(/\//g, '-') + "&pickUpTime=" + startTime[1] + "&returnTime=" + endTime[1] + "&totalDays=" + formData.totalDays + "&pickupLocName=" + encodeURIComponent(selectedPickupLocation[0]) + "&returnLocName=" + encodeURIComponent(selectedReturnLocation[0]) + "&dloc=" + selectedReturnLocation[1] + "&ploc=1" + "&pickupLocationTypeCode=" + selectedPickupLocation[2] + "&returnLocationTypeCode=" + selectedPickupLocation[2] + "&currency=" + currency + "&pickCountry=" + pickCountry + "&dropCountry=" + dropCountry + oldcarParam;
    }
    if (isTestMarket) {
        const geolocationParams = `&pickPlaceId=${encodeURIComponent(pickPlaceId || "")}` +
            `&pickDataSource=${encodeURIComponent(pickDataSource || "")}` +
            `&dropPlaceId=${encodeURIComponent(dropPlaceId || pickPlaceId || "")}` +
            `&dropDataSource=${encodeURIComponent(dropDataSource || pickDataSource || "")}`;
        hrefUrl += geolocationParams;
    }
    //remove "/pages" from hrefUrl if it exists
    if (hrefUrl.includes("/pages")) {
        hrefUrl = hrefUrl.replace("/pages", "");
    }
    const isAbsoluteUrl = /^https?:\/\//i.test(hrefUrl);
    const absoluteUrl = isAbsoluteUrl ? hrefUrl : `${url}${hrefUrl.startsWith("/") ? "" : "/"}${hrefUrl}`;
    sessionStorage.setItem("searchUrl", absoluteUrl);
    sessionStorage.setItem("searchUrlDebug", absoluteUrl);
    return absoluteUrl;
};
export default SubmitSearch;
